export default __webpack_public_path__ + "static/media/ecovole-bg.9a888832.jpg";